<template>
  <div class="button">馆区全景导览</div>
</template>

<style lang="scss" scoped>
.button {
  padding-left: 81px;
  width: 276px;
  height: 76px;
  font-weight: bold;
  color: #d6b970;
  line-height: 74px;
  font-size: 24px;
  cursor: pointer;
  box-sizing: border-box;
  background: url("./bg.png") no-repeat center / contain;
}
</style>
